package com.milta

import kotlin.Boolean
import kotlin.String

internal actual object BuildKonfig {
  public actual val BASE_URL: String = "https://api.milta.test.news.mr"

  public actual val DEV_HOST: String = ""

  public actual val IS_DEV: Boolean = false

  public actual val GOOGLE_WEB_CLIENT_ID: String =
      "815977922005-sqq6idgsb36oblkbfbehf08g4091d0ui.apps.googleusercontent.com"

  public actual val APPLE_SERVICE_ID: String = ""

  public actual val APPLE_REDIRECT_URI: String = ""

  public actual val APPLE_REDIRECT_SCHEME: String = "miltaapp"

  public actual val GOOGLE_REDIRECT_URI: String = ""
}
